import React from 'react'

import Image from '~/truck/image'

interface EmptyStateProps {
  imageUrl: string
  buttonAction: string
  label: string
  onClick: () => void
}

function EmptyState({ imageUrl, buttonAction, label, onClick }: EmptyStateProps) {
  return (
    <div>
      <div className="mb-6 flex gap-4">
        <Image className="size-16" src={imageUrl} />
        <div className="flex flex-col justify-center gap-2">
          <span className="font-semibold">Este producto aún no tiene reseñas</span>
          <span>{label}</span>
        </div>
      </div>
      {/* FIXME: replace with a real button or link */}
      <span className="cursor-pointer font-semibold text-brand-secondary" onClick={onClick}>
        {buttonAction}
      </span>
    </div>
  )
}

export default EmptyState
